import {IEventManagerWithAsync, IService, SystemComponentType} from '@gongxigames/framework/core/types';
import {CoreDI} from '@gongxigames/framework/core/configs';
import {ScreenEvents} from '@gongxigames/framework/core/events';
import {inject, injectable} from '@gongxigames/framework/core/installer';

@injectable()
export class VisibilityManager implements IService {
    public static NAME: symbol = CoreDI.VisibilityManager;
    public type: SystemComponentType = 'service';

    private _visible = true;

    @inject(CoreDI.IEventManagerWithAsync)
    private _eventManager!: IEventManagerWithAsync<ScreenEvents>;

    private visibilityChangeListener: () => void = this.onVisibilityChange.bind(this);

    constructor() {
        document.addEventListener('visibilitychange', this.visibilityChangeListener, false);
    }

    public get visible(): boolean {
        return this._visible;
    }

    public destroy(): void {
        document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }

    private onVisibilityChange(): void {
        if (document.visibilityState === 'visible' && !this._visible) {
            this._visible = true;

            this._eventManager.emit('General.Screen.BECAME_VISIBLE');
        } else if (document.visibilityState === 'hidden' && this._visible) {
            this._visible = false;

            this._eventManager.emit('General.Screen.BECAME_INVISIBLE');
        }
    }
}
